import { useState, useCallback } from 'react';
import { SortDirection } from '@/components/ui/sortable-table-head';

interface UseTableSortOptions {
  defaultSortKey?: string;
  defaultSortDirection?: SortDirection;
  onSortChange?: () => void;
}

export function useTableSort(options: UseTableSortOptions = {}) {
  const { defaultSortKey, defaultSortDirection, onSortChange } = options;
  const [sortKey, setSortKey] = useState<string | null>(defaultSortKey || null);
  const [sortDirection, setSortDirection] = useState<SortDirection>(defaultSortDirection || null);

  const handleSort = useCallback((key: string) => {
    if (sortKey === key) {
      // Toggle direction: null -> asc -> desc -> null
      if (sortDirection === null) {
        setSortDirection('asc');
      } else if (sortDirection === 'asc') {
        setSortDirection('desc');
      } else {
        setSortDirection(null);
        setSortKey(null);
      }
    } else {
      setSortKey(key);
      setSortDirection('asc');
    }
    // Notify parent of sort change (useful for resetting pagination)
    onSortChange?.();
  }, [sortKey, sortDirection, onSortChange]);

  const resetSort = useCallback(() => {
    setSortKey(defaultSortKey || null);
    setSortDirection(defaultSortDirection || null);
  }, [defaultSortKey, defaultSortDirection]);

  return {
    sortKey,
    sortDirection,
    handleSort,
    resetSort,
  };
}
